import React, { ReactElement } from 'react';
import { NotFoundPage, PageLoader } from 'slovlex-idsk-react-components';
import UserRole from '../../../model/currentuser/UserRole';
import CurrentUserDetail from '../../../model/currentuser/CurrentUserDetail';
import { ForbiddenPage } from '../../../page';
import LegislationProcessInfo from '../../../model/currentuser/LegislationProcessInfo';
import ErrorMessagePage from '../../../page/ErrorMessagePage';
import SecuredPageErrorConditions from '../../../model/SecuredPageErrorConditions';
import Layout from '../../../page/Layout';
import useClientStatusContext from '../../../context/ClientStatusContext/context/useClientStatusContext';

interface Props {
  pouzivatel: CurrentUserDetail;
  children: ReactElement;
  allowForRoles?: Array<UserRole>;
  legislationProcess: LegislationProcessInfo;
  errorPageConditions?: SecuredPageErrorConditions;
}

const isAuthorized = (allowForRoles: Array<UserRole>, user: CurrentUserDetail): boolean => {
  const userRoles = user == null ? [] : user.opravnenia;
  if (!allowForRoles) {
    return true;
  }
  if (!userRoles || userRoles.length === 0 || allowForRoles.length === 0) {
    return false;
  }
  return userRoles.some(role => allowForRoles.includes(role));
};

const SecuredPageComponent = ({
  children,
  allowForRoles,
  pouzivatel,
  legislationProcess,
  errorPageConditions,
}: Props): ReactElement => {
  // @ts-ignore
  const errorMessages = errorPageConditions?.conditions?.filter(
    ({ condition }) => condition === false,
  )
    ?.map(({ message }) => message);
  const { status } = useClientStatusContext();

  if (!legislationProcess && !status) {
    return (
      <div className="page-loader">
        <PageLoader loading />
      </div>
    );
  }

  if (!legislationProcess && status) {
    return null;
  }

  if (!legislationProcess.exists) {
    return (
      <Layout>
        <NotFoundPage />
      </Layout>
    );
  }

  if (!isAuthorized(allowForRoles, pouzivatel)) {
    return <ForbiddenPage />;
  }

  if (errorMessages?.length > 0) {
    return <ErrorMessagePage messages={errorMessages} title={errorPageConditions.title} />;
  }

  return children;
};

export default SecuredPageComponent;
